export const isTouchDevice = (): boolean | undefined => {
  if (typeof window !== "undefined") {
    return window.matchMedia("(hover: none), (pointer: coarse)").matches;
  }

  return undefined;
};
